<template>
    <Modal v-if="show" size="lg" @close="$emit('close')">
        <template #body>
            <div class="px-8 pt-8 pb-6 text-center">
                <!-- Title -->
                <h3 class="text-2xl font-bold leading-6 text-gray-900 mb-4">
                    {{ t("vue.youve_reached_your_limit") }}
                </h3>

                <!-- Message -->
                <p class="text-gray-500 text-base mb-8 leading-relaxed">
                    {{ message }}
                </p>

                <!-- Buttons -->
                <div class="flex justify-center space-x-4">
                    <AtomicButton color="white" size="lg" @click="closeModal">
                        {{ t("vue.ok") }}
                    </AtomicButton>
                    <AtomicButton
                        color="red"
                        size="lg"
                        @click="goToSubscription"
                    >
                        {{ t("vue.subscribe") }}
                    </AtomicButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
import { useTranslations } from "@/composables/useTranslations";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";

defineProps<{
    show: boolean;
    message: string;
}>();

const emit = defineEmits<{
    close: [];
}>();

// Get access to translations
const { t } = useTranslations();

const closeModal = () => {
    emit("close");
};

const goToSubscription = () => {
    // Navigate to subscription/billing page
    router.visit(route("billing.subscriptions.index"));
    closeModal();
};
</script>
